import { Box, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ProgressionChartLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography fontWeight="bold">{t("word_legend")}</Typography>
      <Grid container display="flex" rowSpacing={1} columnSpacing={2}>
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing={1}
          columnSpacing={2}
        >
          <Grid item display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#E2772E",
              }}
            ></div>
            <Typography variant="body2" fontSize="12px">
              {t("RetinaLogik Exam")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "blue",
              }}
            ></div>
            <Typography variant="body2" fontSize="12px">
              {t("External Exam")}
            </Typography>
          </Grid>
        </Grid>
        {/* Circle shape */}
        <Grid item display="flex" alignItems="center" gap={1}>
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: "#000",
              borderRadius: "50%",
            }}
          ></div>
          <Typography variant="body2" fontSize="12px">
            {t("fast_threshold")}
          </Typography>
        </Grid>
        {/* Square shape */}
        <Grid item display="flex" alignItems="center" gap={1}>
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: "#000",
            }}
          ></div>
          <Typography variant="body2" fontSize="12px">
            {t("full_threshold")}
          </Typography>
        </Grid>
        {/* Triangle shape */}
        <Grid item display="flex" alignItems="center" gap={1}>
          <div
            style={{
              width: "0px",
              height: "0px",
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderBottom: "10px solid #000",
            }}
          ></div>
          <Typography variant="body2" fontSize="12px">
            {t("standard_threshold")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
